import styled from '@emotion/styled';
import React, { forwardRef } from 'react';

interface IProps {
  title: string;
}

const Link = styled.a`
  display: block;

  &:hover,
  &:focus {
    text-decoration: underline;
  }
`;

export const GroupLink = forwardRef(function GroupLink(
  { title, ...rest }: IProps,
  ref,
) {
  return (
    <Link {...rest} ref={ref as any} title={title}>
      {title}
    </Link>
  );
});
